import React from 'react'

const WhoAreWe = () => {
  return (
    <div>
      
    </div>
  )
}

export default WhoAreWe
